<script setup lang="ts">
import { useBaseStore } from "@/stores/base";
import Navigation from "./Navigation.vue";
import { watch, ref, watchEffect } from "vue";

const store = useBaseStore();

const test = ref(true);
</script>

<template>
	<v-navigation-drawer
		@update:rail="
			(val) =>
				(store.navigationSidebarCollapsed = val && store.navigationMiniSidebar)
		"
		@update:model-value="(val) => console.log(val)"
		left
		v-model="store.navigationShowDesktopDrawer"
		elevation="0"
		rail-width="75"
		:mobile="false"
		app
		color="#F0F3F7"
		class="rail"
		:style="
			store.navigationSidebarCollapsed
				? undefined
				: 'box-shadow: #919eab4d 0 0 2px, #919eab1f 0 12px 24px -4px !important;'
		"
		:rail="true"
		:expand-on-hover="true"
		width="300"
	>
		<Navigation
			v-if="store.navigationStructure !== null && store.moduleRoutesLoaded"
		/>
	</v-navigation-drawer>
</template>

<style lang="scss">
.rail {
	color: rgb(var(--v-theme-on-surface)) !important;
	border: unset !important;
	box-shadow: unset !important;
}
</style>
